import {BACKEND_API} from '../middleware/backend'

export const EXAMS_REQUEST = 'EXAMS_REQUEST';
export const EXAMS_SUCCESS = 'EXAMS_SUCCESS';
export const EXAMS_FAILURE = 'EXAMS_FAILURE';
export const EXAMS_COUNT_REQUEST = 'EXAMS_COUNT_REQUEST';
export const EXAMS_COUNT_SUCCESS = 'EXAMS_COUNT_SUCCESS';
export const EXAMS_COUNT_FAILURE = 'EXAMS_COUNT_FAILURE';
export const EXAM_REQUEST = 'EXAM_REQUEST';
export const EXAM_SUCCESS = 'EXAM_SUCCESS';
export const EXAM_FAILURE = 'EXAM_FAILURE';
export const EXAM_SAVE_REQUEST = 'EXAM_SAVE_REQUEST';
export const EXAM_SAVE_SUCCESS = 'EXAM_SAVE_SUCCESS';
export const EXAM_SAVE_FAILURE = 'EXAM_SAVE_FAILURE';
export const EXAM_INFO_REQUEST = 'EXAM_INFO_REQUEST';
export const EXAM_INFO_SUCCESS = 'EXAM_INFO_SUCCESS';
export const EXAM_INFO_FAILURE = 'EXAM_INFO_FAILURE';

export const loadExams = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [EXAMS_REQUEST, EXAMS_SUCCESS, EXAMS_FAILURE],
			endpoint: "exam/list",
			filter: filter
		}
	})
};

export const countExams = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [EXAMS_COUNT_REQUEST, EXAMS_COUNT_SUCCESS, EXAMS_COUNT_FAILURE],
			endpoint: "exam/count",
			filter: filter
		}
	})
};

export const loadExam = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [EXAM_REQUEST, EXAM_SUCCESS, EXAM_FAILURE],
			endpoint: `exam/${id}`,
		}
	})
};

export const saveExam = (exam) => (dispatch, getState) => {
	return dispatch({
		id: exam.examId,
		exam: exam,
		[BACKEND_API]: {
			types: [EXAM_SAVE_REQUEST, EXAM_SAVE_SUCCESS, EXAM_SAVE_FAILURE],
			endpoint: 'exam',
			body: exam,
			silent: true
		}
	})
};

export const loadExamInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [EXAM_INFO_REQUEST, EXAM_INFO_SUCCESS, EXAM_INFO_FAILURE],
			endpoint: `exam/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/exams.js